import { FormikErrors } from "formik";
import { useTranslation } from "react-i18next";
import "react-intl-tel-input/dist/main.css";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { SharedButton } from "@components";
import { IPhone } from "@interfaces";
import { ModulesTelInput } from "@modules";
import { selectMerchant } from "@redux";
interface IProps {
    values: IPhone;
    errorPhone: string;
    isSubmitting: boolean;
    handleSubmit: (e?: React.FormEvent<HTMLFormElement> | undefined) => void;
    setFieldTouched: (
        field: string,
        touched?: boolean | undefined,
        shouldValidate?: boolean | undefined
    ) => Promise<void> | Promise<FormikErrors<IPhone>>;
    setFieldValue: (
        field: string,
        value: any,
        shouldValidate?: boolean | undefined
    ) => Promise<void> | Promise<FormikErrors<IPhone>>;
    setError: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export const ComponentSignUpTel = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //page props
    const {
        values,
        isSubmitting,
        handleSubmit,
        setFieldTouched,
        setFieldValue,
        errorPhone,
        setError,
    } = props;
    //page variable
    const { themes } = useSelector(selectMerchant);

    return (
        <>
            <p className="label-sginup">{t("page.enter_your_phone_number")}</p>
            <form onSubmit={handleSubmit}>
                <ModulesTelInput
                    setFieldTouched={setFieldTouched}
                    setFieldValue={setFieldValue}
                    value={values.phoneNumber || ""}
                    errorPhone={errorPhone}
                    setError={setError}
                />
                <StyledButton
                    size="large"
                    bg_color={themes?.themeColor!}
                    disabled={isSubmitting}
                    type="submit"
                    className="btn-text"
                >
                    {t("page.confirm")}
                </StyledButton>
            </form>
        </>
    );
};

const StyledButton = styled(SharedButton)`
    margin-top: 24px;
    border-radius: 36px;
    &:focus-visible {
        outline: none;
    }
`;
